export enum ReportComponentExportType {
  CSV = 'csv',
  XLSX = 'xlsx',
  IMG = 'img',
  PDF = 'pdf',
}

export enum ReportDashboardExportType {
  CSV = 'csv',
  XLSX = 'xlsx',
  IMG = 'img',
  PDF = 'pdf',
}

export const EXPORTS_MAX_FIRST_DIMENSION_LENGTH = 25;

export const EXPORT_TRUNCATE_LEGEND_LENGTH = 20;
